import * as React from 'react'

import CircleIcon from '@mui/icons-material/Circle'
import { Typography } from '@mui/material'

import { ProductProductPartStatusEnum } from '@/gen/ecom'
import { useTranslations } from '@/hooks/useTranslations'

interface StatusProps {
  partStatus?: string
}
/**
 * Show label based on product part status, BE will show or hide product
 *
 * - A: (Active) No label, BE: show product
 * - O: (Obsolete) Show <label> Discontinued, BE: show product for next 6 months
 * - P: (Phased out) Show <label> Udgår snart, BE: show product for rest of stock
 * - D: (Depletion) No label, BE: hide product
 * - S: (Sales Stop) No label, BE: hide product
 * - T: (Tender product ) No label, BE: hide product
 * - N: (New product) No label, BE: hide product
 */
export const PartStatusLabel: React.FC<StatusProps> = ({ partStatus }) => {
  const { translate } = useTranslations()

  const partStatusMap = {
    expiresSoon: { translation: translate('product.stockLevelMessage.expiresSoon'), color: 'warning.main' },
    discontinued: { translation: translate('product.stockLevelMessage.discontinued'), color: 'error.main' },
  }

  const getStockLevelStatus = React.useMemo(() => {
    switch (partStatus) {
      case ProductProductPartStatusEnum.P:
        return partStatusMap['expiresSoon']
      case ProductProductPartStatusEnum.O:
        return partStatusMap['discontinued']
      default:
        return null
    }
  }, [partStatusMap])

  if (getStockLevelStatus == null) {
    return null
  }

  return (
    <Typography data-testid={partStatusMap} variant="h5" sx={{ display: 'flex', color: getStockLevelStatus.color }}>
      <CircleIcon
        sx={{
          height: '0.8rem',
          width: '0.8rem',
          mr: 0.8,
          mt: 0.4,
          color: getStockLevelStatus.color,
        }}
      />
      <span>{getStockLevelStatus.translation}</span>
    </Typography>
  )
}
